import React from "react";
import contactImg from "../../assets/img/illustrations/sign-up.png";
import { Row } from "reactstrap";
import emailJs from "@emailjs/browser";
import $ from "jquery";
import { success } from "../../functions";

const ContactUs = () => {
  const onSubmit = (e) => {
    e.preventDefault();

    const data = {
      name: $("#name").val(),
      subject: $("#subject").val(),
      email: $("#email").val(),
      message: $("#message").val(),
    };

    emailJs
      .send("service_p1qfzxp", "template_nysvptg", data, "yND8psRHEmB_0Pxjp")
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          e.target.reset();
          $.dialog({
            title: "Success",
            theme: "modern",
            type: "green",
            backgroundDismiss: true,
            content:
              "You have successfully contacted us. We will get back to you. Thank you.",
          });
        },
        (err) => {
          $.dialog({
            title: "Failed",
            theme: "modern",
            type: "red",
            backgroundDismiss: true,
            content:
              "The message failed to reach us please try again. Thank you",
          });
          console.log("FAILED...", err);
        }
      );
  };

  return (
    <section className="my-5 pt-5">
      <div className="container">
        <div className="row">
          <div className="col-md-6 m-auto">
            <h4>Contact</h4>
            <p
              className="mb-0 small"
              style={{ fontSize: "1rem!important", lineHeight: "1.3rem" }}
            >
              For further questions, including partnership opportunities, please
              email info@sme.com or contact using our contact form.
            </p>

            <form
              id="contact-form"
              method="post"
              autoComplete="off"
              onSubmit={onSubmit}
            >
              <div className="card-body pb-2">
                <div className="row">
                  <div className="col-md-6">
                    <label>Full Name</label>
                    <div className="input-group mb-4">
                      <input
                        className="form-control"
                        placeholder="Full Name"
                        aria-label="Full Name"
                        type="text"
                        id="name"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 ps-md-2 mb-4">
                    <label>Email</label>
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="your@email.com"
                        id="email"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12 mb-4">
                    <label>Subject</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="email header"
                        id="subject"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label>How can we help you?</label>
                    <div className="input-group">
                      <textarea
                        name="message"
                        className="form-control"
                        id="message"
                        rows="6"
                        placeholder="Describe your problem"
                        required
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <Row className="">
                <div className="col-4">
                  <button
                    type="submit"
                    className="contactBtn"
                  >
                    Send
                  </button>
                </div>
              </Row>
            </form>
          </div>
          <div className="col-md-5 ms-auto">
            <div className="position-relative">
              <img
                className="max-width-50 w-100 position-relative z-index-2"
                src={contactImg}
                alt="Contact"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
